// dependencies
import { Map, List } from "immutable";

export const getDeployments = (state) => state.getIn(["deployments", "deploymentsList"], List());
export const getDeploymentsInfo = (state) => state.getIn(["deployments", "deploymentInfo"], Map());
